import { Headline } from './Headline'

/**
 * Kurzfassungen der Stationen aus Version 5. Pro Station eine Headline
 * (höchstens acht Wörter) und eine Zeile. Intro, Rückspulen und Finale haben
 * schon großen Text im Bild und brauchen keine.
 */
export const HEADLINES = {
  ohne: {
    title: 'Gute Lebensläufe, falsche Besetzung.',
    line: 'Mara prüft jede Bewerbung gründlich. Trotzdem passt der Neue nicht ins Team und geht wieder.'
  },
  hr: {
    title: 'Diesmal holt sich Mara Aivy dazu.',
    line: 'Mit einer Aivy-Vorlage, mit den Fachbereichen oder mit beidem.'
  },
  analyse: {
    title: 'Die Fachbereiche sagen, was zählt.',
    line: 'Jede Person füllt die Anforderungsanalyse selbst aus. HR hat keinen Aufwand.'
  },
  profil: {
    title: 'Daraus wird das Anforderungsprofil.',
    line: 'Mit Ideal- und Übergangsbereich für jede Dimension.'
  },
  bewerbungen: {
    title: 'Hinter jedem Lebenslauf steckt ein Mensch.',
    line: 'Mit Stärken, die auf keinem Papier stehen.'
  },
  games: {
    title: 'Spielen statt Fragebogen.',
    line: 'Kurze Spiele am Smartphone zeigen, was in jeder Person steckt.'
  },
  magic: {
    title: 'Ein Blick in Aivy.',
    line: 'Aus dem Spielverhalten werden validierte Dimensionen, daraus die Passung.',
    place: 'bottom'
  },
  regeln: {
    title: 'Feste Regeln statt Blackbox.',
    line: 'Jede Passung bleibt nachvollziehbar, bis auf die einzelne Dimension.'
  },
  talente: {
    title: 'Alle bekommen ihr Stärkenprofil.',
    line: 'Kostenlos und persönlich. Das schafft Akzeptanz.'
  },
  report: {
    title: 'Die drei Passendsten treten vor.',
    line: 'Kernstück ist das Passungsprofil als PDF. Der Assistent hilft beim Nachfragen.'
  },
  kreuz: {
    title: 'Jonas passt woanders besser.',
    line: 'Dank Kreuzmatching geht er in den Vertrieb, statt verloren zu gehen.'
  },
  gespraech: {
    title: 'Ein Gespräch, gut vorbereitet.',
    line: 'Aivy schlägt Interviewfragen aus Lenas Passungsprofil vor.'
  },
  team: {
    title: 'Diesmal bleibt der Platz besetzt.',
    line: 'Lena passt zur Aufgabe und zum Team.'
  },
  absagen: {
    title: 'Faire Absagen für alle anderen.',
    line: 'Gleiche Kriterien, datenbasiert und begründbar. Das gibt HR Sicherheit.'
  },
  ats: {
    title: 'Direkt in deinem ATS.',
    line: 'Mit dem Sidebar-Plugin sind Assistent und Auswertung dort, wo du arbeitest.'
  },
  support: {
    title: 'Und wir helfen gern.',
    line: 'Schnell und persönlich, wenn mal eine Frage offen ist.'
  }
}

/** Ersetzt in KombiStory die Captions durch Headlines. */
export const headlineLayer = (BEATS) =>
  BEATS.filter((b) => HEADLINES[b.id]).map((b) => {
    const [s, e] = b.at
    const len = e - s
    // Kurz lesen, dann Platz machen für die Szene
    return (
      <Headline
        key={b.id}
        show={[s + len * 0.02, s + len * 0.14]}
        hide={[s + len * 0.34, s + len * 0.42]}
        {...HEADLINES[b.id]}
      />
    )
  })
